var exports = {
  "iU": "Message.module__message___WHU2ak",
  "Ph": "Message.module__messagePreviewSpacing___WHU2ak",
  "IL": "Message.module__messagePreview___WHU2ak",
  "Xo": "Message.module__messageHovered___WHU2ak",
  "uK": "Message.module__focusRingAnchor___WHU2ak",
  "J8": "Message.module__messageCompact___WHU2ak",
  "L8": "Message.module__messageMentioned___WHU2ak",
  "m6": "Message.module__messageReplying___WHU2ak",
  "O6": "Message.module__messageHighlight___WHU2ak",
  "lY": "Message.module__contextMenuActive___WHU2ak",
  "Bc": "Message.module__mobileLayout___WHU2ak",
  "p2": "Message.module__messageLongPress___WHU2ak",
  "Uw": "Message.module__messageGrouped___WHU2ak",
  "kT": "Message.module__messageEditing___WHU2ak",
  "E4": "Message.module__messageSent___WHU2ak",
  "mr": "Message.module__messageSending___WHU2ak",
  "b$": "Message.module__messageFailed___WHU2ak",
  "RZ": "Message.module__failedFooter___WHU2ak",
  "Iu": "Message.module__failedFooterMessage___WHU2ak",
  "bg": "Message.module__failedFooterLabel___WHU2ak",
  "OZ": "Message.module__failedFooterIcon___WHU2ak",
  "dv": "Message.module__failedRetryIcon___WHU2ak",
  "QW": "Message.module__failedRetryButton___WHU2ak",
  "q5": "Message.module__messageGutterLeft___WHU2ak",
  "ZN": "Message.module__messageGutterRight___WHU2ak",
  "$7": "Message.module__messageAvatar___WHU2ak",
  "CW": "Message.module__messageNoText___WHU2ak",
  "U7": "Message.module__messageContent___WHU2ak",
  "rO": "Message.module__messageAuthorInfo___WHU2ak",
  "xW": "Message.module__jumpHeading___WHU2ak",
  "RO": "Message.module__jumpHeadingButton___WHU2ak",
  "dw": "Message.module__messageAuthorRow___WHU2ak",
  "um": "Message.module__messageUsername___WHU2ak",
  "Lo": "Message.module__messageText___WHU2ak",
  "AY": "Message.module__messageAuthorPart___WHU2ak",
  "oL": "Message.module__messageTimestamp___WHU2ak",
  "L5": "Message.module__messageTimestampCompact___WHU2ak",
  "tQ": "Message.module__compactAuthorPrefix___WHU2ak",
  "U6": "Message.module__copyOnly___WHU2ak",
  "Mz": "Message.module__compactInlineContent___WHU2ak",
  "aM": "Message.module__systemMessageContent___WHU2ak",
  "vp": "Message.module__contextMenuUnderline___WHU2ak",
  "aE": "Message.module__messageTimeoutIndicator___WHU2ak",
  "t4": "Message.module__textSeparator___WHU2ak",
  "BK": "Message.module__authorDashSeparator___WHU2ak",
  "KL": "Message.module__messageTimestampHover___WHU2ak",
  "jh": "Message.module__messageTimestampCompactHover___WHU2ak",
  "iZ": "Message.module__messageAvatarCompact___WHU2ak",
  "kq": "Message.module__compactContentWrapper___WHU2ak",
  "xv": "Message.module__hoverAction___WHU2ak",
  "kL": "Message.module__container___WHU2ak",
  "tI": "Message.module__repliedMessage___WHU2ak",
  "_T": "Message.module__repliedMessageCompact___WHU2ak",
  "$y": "Message.module__repliedTextPreview___WHU2ak",
  "NL": "Message.module__repliedAvatar___WHU2ak",
  "a3": "Message.module__repliedIconContainer___WHU2ak",
  "Pq": "Message.module__repliedIcon___WHU2ak",
  "EK": "Message.module__repliedUsername___WHU2ak",
  "IQ": "Message.module__repliedItalic___WHU2ak",
  "Mx": "Message.module__unstyled___WHU2ak",
  "Io": "Message.module__repliedTextContent___WHU2ak",
  "c": "Message.module__systemMessageFollowsSystem___WHU2ak",
  "Hj": "Message.module__systemMessageIconWrapper___WHU2ak",
  "Po": "Message.module__systemMessageIconCompact___WHU2ak",
  "jJ": "Message.module__systemMessageTimestamp___WHU2ak",
  "rc": "Message.module__systemMessageContentWrapper___WHU2ak",
  "V_": "Message.module__systemMessageCompactContent___WHU2ak",
  "Gq": "Message.module__systemMessageIconSvg___WHU2ak",
  "hr": "Message.module__systemMessageLink___WHU2ak",
  "x": "Message.module__userTagOffset___WHU2ak",
  "ll": "Message.module__userTagCompact___WHU2ak",
  "O4": "Message.module__editedTimestamp___WHU2ak",
  "k8": "Message.module__editedLabel___WHU2ak",
  "zX": "Message.module__typingContainer___WHU2ak",
  "Y9": "Message.module__typingCluster___WHU2ak",
  "RL": "Message.module__typingIndicator___WHU2ak",
  "Kl": "Message.module__typingAvatarContainer___WHU2ak",
  "tY": "Message.module__typingText___WHU2ak",
  "AZ": "Message.module__typingClusterComposerStatus___WHU2ak",
  "am": "Message.module__compactContentNoPrefix___WHU2ak",
  "Ys": "Message.module__compactBody___WHU2ak",
  "Ac": "Message.module__unknownMessageCompactContent___WHU2ak",
  "qU": "Message.module__unknownMessageWarning___WHU2ak",
  "NG": "Message.module__keyboardFocused___WHU2ak",
  "an": "Message.module__messageClientSystem___WHU2ak",
  "og": "Message.module__systemMessageContainer___WHU2ak",
  "Is": "Message.module__systemMessageIcon___WHU2ak",
  "ry": "Message.module__mediaFocusRing___WHU2ak",
  "xS": "Message.module__systemMessageDismissButton___WHU2ak",
  "Eu": "Message.module__silentMessageIcon___WHU2ak",
};

module.exports = exports;
